module.exports = __webpack_public_path__ + "static/media/eye_close.2859d58b.svg";